import React, { useState } from 'react';
import { Box, Button, Grid, Modal, Typography } from '@mui/material';
import { FILTER_FLOAT_BUTTON_Z_INDEX_DESKTOP } from 'src/const';
import TabBar from 'src/App/Components/Tabs/TabBar';
import { COLOR_PRIMARY_2 } from 'src/colors';

const BottomDrawer = ({
  topComponents,
  components,
  isOverLayVisible,
  overlayButton,
  setMapHeightOnMobileView,
}: {
  topComponents: JSX.Element[];
  components: {[key: string]: JSX.Element[]};
  isOverLayVisible: boolean;
  overlayButton: JSX.Element;
  setMapHeightOnMobileView: React.Dispatch<React.SetStateAction<number>>;
}) => {
  const [currentTab, setCurrentTab] = useState<'overview' | 'listings'>('listings');
  const mobileDrawerTabs = {
    overview: {
      label: 'Overview',
      value: 'overview',
      icon: null,
      onclick: () => {
        setCurrentTab('overview');
        setMapHeightOnMobileView(60);
      },
      height: '40vh',
    },
    listings: {
      label: 'Listings',
      value: 'listings',
      icon: null,
      onclick: () => {
        setCurrentTab('listings');
        setMapHeightOnMobileView(40);
      },
      height: '60vh',
    },
  };


  return (
    <>
      <Box
        sx={{
          position: 'absolute',
          left: 0,
          bottom: 0,
          width: '100%',
          height: mobileDrawerTabs[currentTab].height,
          maxHeight: '80vh',
          display: 'flex',
          flexDirection: 'column',          
        }}
      >
        <Box
          sx={{
            height: '30px',
            display: 'flex',
            justifyContent: 'space-between',
            padding: 'auto 5px',
            paddingLeft: '10px',
            marginRight: '10px',
            paddingBottom: '5px',
            pointerEvents: 'none',
          }}
        >
          {topComponents.map(component => component)}
        </Box>

        <Box
          sx={{
            backgroundColor: '#fff',
            borderTopLeftRadius: '24px',
            borderTopRightRadius: '24px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <TabBar
            tabList={Object.values(mobileDrawerTabs)}
            currentTab={currentTab}
            color={COLOR_PRIMARY_2}
            renderLabelCondition={() => true}
            actionButton={[]}
            showActionButton={false}
            transparentBackground={true}
          />
        </Box>

        <Box
          sx={{
            flex: 1,
            overflowY: 'auto',
            background: '#fff',
            width: '100%',
            pl: 2,
            pr: 2,
            position: 'relative',
          }}
        >
          {currentTab === 'overview' && isOverLayVisible && (
            <Box
              sx={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '3400px',
                backgroundColor: 'rgba(255, 255, 255, 0.8)',
                zIndex: FILTER_FLOAT_BUTTON_Z_INDEX_DESKTOP - 1,
              }}
            >
              <div
                style={{
                  position: 'sticky',
                  top: '25%',
                  display: 'flex',
                  justifyContent: 'center',
                }}
              >
                {overlayButton}
              </div>
            </Box>
          )}

          <Grid
            container
            direction="column"
            xs={12}
            spacing={2}
            justifyContent="flex-start"
            alignItems="center"
          >
            <Grid item xs={12} sx={{ width: '100%' }}></Grid>
            {components[currentTab].map((component, index) => (
              <Grid item xs={12} key={index} sx={{ width: '100%' }}>
                {component}
              </Grid>
            ))}
          </Grid>
        </Box>
      </Box>
    </>
  );
};

export default BottomDrawer;
